import apiFetch from '../apiFetch'

export default function (token, income) {
  return apiFetch({ endPoint: 'PaperworkType/Master/Create', method: 'POST', body: income, token: token })
}
